// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","image":"Card_image__ZlhbW","name":"Card_name__Qjf9y","link":"Card_link__379CA","hs":"Card_hs__CueJf"};